import React, { useState } from "react";
import * as yup from "yup";
import ContentLayout from "../../../../partials/content/ContentLayout";
import { saveIncomingPayment } from "../../../../services/finance/incomingPayment";
import Swal from "sweetalert2";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import AppForm from "../../../../partials/content/Forms/AppForm";
import IncomingPaymentContent from "./incomingPaymentContent";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";

const paymentSchema = yup.object().shape({
  ID: yup.number(),
  docRef: yup.string(),
  invoiceID: yup.number(),
  invoiceCode: yup.string().required("A/R Invoice ID is required"),
  customerID: yup.number(),
  customerName: yup.string().required("Customer is required"),
  paymentDate: yup.date().required("Payment Date is required"),
  cashAccountID: yup.number().min(1, "Cash Account is required"),
  currencyID: yup.number(),
  currencyCode: yup.string(),
  paymentAmount: yup
    .number()
    .transform((value) => (isNaN(value) ? 0 : value))
    .nullable()
    .required("Payment Amount is required")
    .min(1, "Payment Amount cannot be zero or empty")
    .default(0),
  invoiceAmount: yup.number(),
  exchangeRate: yup.number().min(1, "Exchange Rate cannot be zero or empty"),
  note: yup.string(),
});
const IncomingPaymentForm = ({ history }) => {
  const { companyProfile } = useGlobalData();
  const [payment, setPayment] = useState({
    docRef: "1",
    invoiceID: 0,
    invoiceCode: "",
    customerID: 0,
    customerName: "",
    paymentDate: DateTime.now().startOf("day"),
    cashAccountID: 0,
    currencyID: companyProfile.currency.ID,
    currencyCode: companyProfile.currency.currencyCode,
    paymentAmount: 0,
    invoiceAmount: 0,
    exchangeRate: 1,
    note: "",
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  });

  return (
    <React.Fragment>
      <PageSubHeader
        title="Account Receivable Payment Form"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/payments/AR",
            title: "A/R Payments",
            active: false,
          },
          {
            page: "/finance/create-incoming-payment",
            title: "A/R Payment Form",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/finance/payments/AR");
            },
          },
        ]}
      />
      <AppForm
        initialValues={payment}
        validationSchema={paymentSchema}
        headSubmitButton
        onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {
          values.invoiceAmount = parseFloat(values.invoiceAmount);
          values.paymentAmount = parseFloat(values.paymentAmount);
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title:
                "Are you sure want to save this Account Receivable Payment ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveIncomingPayment(values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  resetForm();
                  history.push("/finance/payments/AR");
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
      >
        <ContentLayout>
          <IncomingPaymentContent />
        </ContentLayout>
      </AppForm>
    </React.Fragment>
  );
};

export default IncomingPaymentForm;
